/**
 * Version 1 to 2: progression arrives.
 *
 * Every version 1 record was written before experience and perks existed, so every version 1
 * character is level one with nothing taken. The step adds that section and nothing else.
 *
 * It does not touch `schemaVersion`: `runMigrations` stamps `from + 1` on whatever comes back, so a
 * step that set its own version would be the second place the number is decided. It does not
 * validate either, for the reason the module states in its own words: a step assumes the record is
 * the shape its own version wrote, and `readProfile` validates once, after the whole chain has run.
 * A `progress` already present on a version 1 record is not this step's business, and it is
 * overwritten rather than trusted, because nothing that wrote version 1 ever wrote one.
 */

import type { SaveMigration, SaveRecord } from '@/save/migrationContract';

export const ADD_PROGRESSION: SaveMigration = {
  from: 1,
  apply(record: SaveRecord): SaveRecord {
    return { ...record, progress: { xp: 0, perkRanks: {} } };
  },
};
